const input = document.getElementById("iccid-input");
const searchBtn = document.getElementById("iccid-search");
const apiUrl = `https://shopifyrecharge.desim.tech/cms-api/business/esimRecord/checkCid/`;

// 从 step0.js 移过来的工具函数
const esimImageCover = `
  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="32px" width="32px" xmlns="http://www.w3.org/2000/svg">
    <rect width="416" height="352" x="48" y="80" fill="none" stroke-linejoin="round" stroke-width="32" rx="48" ry="48"></rect>
    <circle cx="336" cy="176" r="32" fill="none" stroke-miterlimit="10" stroke-width="32"></circle>
    <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="m304 335.79-90.66-90.49a32 32 0 0 0-43.87-1.3L48 352m176 80 123.34-123.34a32 32 0 0 1 43.11-2L464 368">
    </path>
  </svg>
`;

function getUserCard(lineId) {
  return fetch(
    `https://shopifyrecharge.desim.tech/cms-api/open/lineController/getESIMListByEmailAndUserId?userId=${lineId}`
  )
    .then((response) => response.json())
    .then((data) => {
      if (data.code === 200) {
        const esimList = data.data
          .filter(item => item.esimStatus !== "2")
          .map((it) => {
            return {
              cover: it.productImage,
              name: it.productShortName || it.productName,
              expireDate: it.expirationTime,
              coverage: it.country,
              ...it,
              esimStatus: !it.activationCode ? "4" : it.esimStatus,
              disabled: !it.activationCode || it.esimStatus === "0" || it.esimStatus === "4" || !(it.joyRsp === 3 || it.joyRsp === 2)
            };
          })
          .reverse();
        return esimList;
      } else {
        throw new Error(data.msg || "Error");
      }
    })
    .catch((error) => {
      console.error("getUserCard error:", error);
      throw error;
    });
}

function getStatusValue(key) {
  const lang = document.documentElement.getAttribute('lang') || 'ja';
  const statusMap = {
    "en": {
      "0": "Not Activated",
      "1": "Activated",
      "2": "Expired",
      "3": "Data Limit Reached",
      "4": "Reserved",
    },
    "ja": {
      "0": "未アクティブ",
      "1": "アクティブ済",
      "2": "期限切れ",
      "3": "容量切れ",
      "4": "予約済",
    }
  };
  const targetLangMap = statusMap[lang] || statusMap.ja; 
  if (key == null || key === "") {
    return "";
  }
  key = String(key);
  return targetLangMap[key] ?? "";
}

function getBackground(esimStatus) {
  switch (esimStatus) {
    case "3": return "#DD2F2C";    // 红色
    case "1": return "#FFB61D";    // 橙色
    case "2": return "#EF9C11";    // 深橙色
    case "0":
    case "4":
    default:  return "rgba(151, 160, 178, 0.17)"; // 默认灰色
  }
}

function initQRCode() {
  const url = new URL(window.location)
  const currentStep = parseInt(url.searchParams.get("step")) || 1;
  const qr_code = url.searchParams.get("qr_code")
  if (currentStep === 1 && qr_code) {
    toggleInputMethod('manual')
    input.value = qr_code
    searchBtn.disabled = false
  }
}

function initInputMethodSelection() {
  const codeWrapper = document.getElementById('code-wrapper');
  const manualWrapper = document.getElementById('manual-wrapper');
  
  if (codeWrapper && manualWrapper) {
    codeWrapper.addEventListener('click', () => {
      toggleInputMethod('code');
    });
    
    manualWrapper.addEventListener('click', () => {
      toggleInputMethod('manual');
    });
  }
}

function toggleInputMethod(method) {
  const codeWrapper = document.getElementById('code-wrapper');
  const manualWrapper = document.getElementById('manual-wrapper');
  const codeInput = document.querySelector('.code-input')
  const manualInput = document.querySelector('.manual-input')
  const searchBtn = document.getElementById('iccid-search');
  
  // 获取两个输入框元素
  const iccidInput = document.getElementById('iccid-input');
  const qrcodeInput = document.getElementById('qrcode-input');
  
  if (method === 'code') {
    if (!codeWrapper.classList.contains('active')) {
      // 清空输入框内容
      if (iccidInput) iccidInput.value = '';
      if (qrcodeInput) qrcodeInput.value = '';
      
      // 清空错误提示
      hideError();
      if (iccidInput) iccidInput.removeAttribute('data-result');
      if (qrcodeInput) qrcodeInput.removeAttribute('data-result');
      // 隐藏所有错误状态
      const invalidStatus2 = document.querySelector('.invalid-status-2');
      const invalidStatus3 = document.querySelector('.invalid-status-3');
      if (invalidStatus2) invalidStatus2.classList.add('hide');
      if (invalidStatus3) invalidStatus3.classList.add('hide');
      
      codeWrapper.classList.add('active');
      codeInput.classList.add('active')
      manualWrapper.classList.remove('active');
      manualInput.classList.remove('active')
      // 显示选择弹窗
      showSourceSelectionModal();
    }
  } else if (method === 'manual') {
    if (!manualWrapper.classList.contains('active')) {
      // 清空输入框内容
      if (iccidInput) iccidInput.value = '';
      if (qrcodeInput) qrcodeInput.value = '';
      
      // 清空错误提示
      hideError();
      if (iccidInput) iccidInput.removeAttribute('data-result');
      if (qrcodeInput) qrcodeInput.removeAttribute('data-result');
      // 隐藏所有错误状态
      const invalidStatus2 = document.querySelector('.invalid-status-2');
      const invalidStatus3 = document.querySelector('.invalid-status-3');
      if (invalidStatus2) invalidStatus2.classList.add('hide');
      if (invalidStatus3) invalidStatus3.classList.add('hide');
      
      manualWrapper.classList.add('active');
      manualInput.classList.add('active')
      codeWrapper.classList.remove('active');
      codeInput.classList.remove('active')
      // 关闭选择弹窗（如果打开）
      hideSourceSelectionModal();
    }
  }
  
  // 更新搜索按钮状态（切换后输入框为空，所以禁用按钮）
  if (searchBtn) {
    searchBtn.disabled = true;
  }
}

function getCurrentInput() {
  // 桌面端（宽度大于749px）只使用手动输入
  if (window.innerWidth > 749) {
    return document.getElementById("iccid-input");
  }
  
  // 移动端根据active状态选择输入框
  const manualInput = document.getElementById("iccid-input");
  const qrcodeInput = document.getElementById("qrcode-input");
  
  const manualWrapper = document.getElementById("manual-wrapper");
  const codeWrapper = document.getElementById("code-wrapper");
  
  if (manualWrapper && manualWrapper.classList.contains("active")) {
    return manualInput;
  } else if (codeWrapper && codeWrapper.classList.contains("active")) {
    return qrcodeInput;
  }
  
  return null;
}

function setBtnLoading(status) {
  if (status) {
    searchBtn.classList.add("loading");
  } else {
    searchBtn.classList.remove("loading");
  }
}

function setBtnDisabled(status) {
  if (status) {
    searchBtn.disabled = true;
  } else {
    searchBtn.disabled = false;
  }
}

function showError(message) {
  document.querySelector('.invalid-status-2').classList.add('hide');
  document.querySelector('.invalid-status-3').classList.add('hide');
  const errorWrapper = document.querySelector(".error-message-wrapper");
  const errorMessage = document.querySelector(".error-message");

  if (errorWrapper && errorMessage) {
    errorMessage.textContent = message;
    errorWrapper.style.display = "flex";
  }
}

function hideError() {
  const errorWrapper = document.querySelector(".error-message-wrapper");

  if (errorWrapper) {
    errorWrapper.style.display = "none";
  }
}

function observeDataResult() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-result"
      ) {
        const currentInput = getCurrentInput();
        if (!currentInput) return;
        
        const result = currentInput.getAttribute("data-result");

        if (result && result.trim() !== "") {
          showError(result);
        } else {
          hideError();
        }
      }
    });
  });

  // 观察两个输入框
  const manualInput = document.getElementById("iccid-input");
  const qrcodeInput = document.getElementById("qrcode-input");
  
  if (manualInput) {
    observer.observe(manualInput, {
      attributes: true,
      attributeFilter: ["data-result"],
    });
  }
  
  if (qrcodeInput) {
    observer.observe(qrcodeInput, {
      attributes: true,
      attributeFilter: ["data-result"],
    });
  }

  return observer;
}

function init() {
  observeDataResult();
  setupInputListeners();
  initInputMethodSelection();
  initQRCode()
  initViewEsimButton();

  const currentInput = getCurrentInput();
  if (currentInput) {
    const initialResult = currentInput.getAttribute("data-result");
    if (initialResult && initialResult.trim() !== "") {
      showError(initialResult);
    }
  }
}

// 为两个输入框添加事件监听器
function setupInputListeners() {
  const manualInput = document.getElementById("iccid-input");
  const qrcodeInput = document.getElementById("qrcode-input");
  
  function handleInput(e) {
    setBtnDisabled(!e.target.value);
    if (e.target.value.trim() !== "") {
      hideError();
    }
  }
  
  if (manualInput) {
    manualInput.addEventListener("input", handleInput);
  }
  
  if (qrcodeInput) {
    qrcodeInput.addEventListener("input", handleInput);
  }
}
function formatExpiryByCountry(daysByCountry) {
  return daysByCountry
    .map(item => {
      const remainingDays = item.totalDays - item.usedDays;

      if (remainingDays <= 0) {
        return `${item.country}-期限切れ`;
      }

      return `${item.country}-${remainingDays}`;
    })
    .join("/");
}

function getRemainDate(expirationTime) {
  const now = new Date();
  const targetDate = new Date(expirationTime);
  if (Number.isNaN(targetDate.getTime())) {
    return NaN;
  }
  const timeDiff = targetDate - now;
  return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
}
function formatDate(expirationTime) {
  const dateObj = new Date(expirationTime);
  if (Number.isNaN(dateObj.getTime())) {
    return '--';
  }
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
function getPlanExpirationDate(value) {
  const planDays = Number(value?.salePlanDays);
  let baseDate = null;

  if (value?.tcreate) {
    const tcreateDate = new Date(value.tcreate);
    if (!Number.isNaN(tcreateDate.getTime())) {
      baseDate = tcreateDate;
    }
  }

  if (!baseDate && value?.departureDate) {
    const departureMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.departureDate);
    if (departureMatch) {
      const [, year, month, day] = departureMatch;
      baseDate = new Date(Number(year), Number(month) - 1, Number(day));
    } else {
      const departureDate = new Date(value.departureDate);
      if (!Number.isNaN(departureDate.getTime())) {
        baseDate = departureDate;
      }
    }
  }

  if (baseDate && Number.isFinite(planDays)) {
    const expirationDate = new Date(baseDate);
    expirationDate.setDate(expirationDate.getDate() + planDays);
    return expirationDate;
  }

  return value?.expirationTime || null;
}
searchBtn.addEventListener("click", () => {
  const currentInput = getCurrentInput();
  if (!currentInput) {
    console.error("No active input found");
    return;
  }
  
  setBtnLoading(true);
  hideError();
  fetch(apiUrl + currentInput.value)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((res) => {
      if (res.code === 200) {
        const value = res.data.productEntity;
        let remain_data = '--';
        try {
          const dataMB = JSON.parse(res.data.quotaGB); // 单位是 MB
          if (dataMB < 1000) {
            remain_data = dataMB.toFixed(2) + 'MB'; // 直接显示 MB，保留 2 位小数
          } else {
            remain_data = (dataMB / 1000).toFixed(2) + 'GB'; // 超过 1000MB 时转成 GB
          }
        } catch(e) {
          remain_data = '--';
        }
        localStorage.removeItem('first-recharge')
        if (res.data.productType === '1') {
          remain_data = '無制限'
          if (!res.data.rechargeRecords?.length) {
            localStorage.setItem('first-recharge', 'true')
          } 
        }
        const lang = document.documentElement.getAttribute('lang')
        const planExpirationDate = getPlanExpirationDate(value)
        const remainDays = getRemainDate(planExpirationDate)
        const expirationTime = Number.isNaN(remainDays) ? '--' : remainDays <= 0 ? lang === 'ja' ? '期限切れ' : 'Expired' : remainDays
        let expirationStr = ''
        if (remain_data === '無制限') {
          if (Array.isArray(res.data.daysByCountry)) {
            expirationStr = formatExpiryByCountry(res.data.daysByCountry)
          }
          const countryDom = document.querySelector('.region_value')?.parentElement
          if (countryDom) {
            countryDom.style.display = 'none'
          }
          const expireLabelDom = document.querySelector('.expiration_date_value')?.previousElementSibling
          if (expireLabelDom) {
            expireLabelDom.innerHTML = 'eSIM本体有効期限'
          }
          localStorage.setItem('remainDays', remainDays)
        } else {
          localStorage.removeItem('remainDays')
        }
        const data = [
          {label: 'region_value', value: value.country },
          {label: 'plan_value', value: value.salePlanName },
          {label: 'expiration_date_value', value: formatDate(planExpirationDate) },
          {label: 'remain_date_value', value: remain_data === '無制限' ? expirationStr  : expirationTime },
          {label: 'remain_data_value', value: remain_data }
        ]
        const product_id = value.productId
        let top_up_status = 2
        if (res.data.checkRecharge === "OK" && (value.joyRsp === 3 || value.joyRsp === 2)) {
          top_up_status = 1 //可以充值
        } else {
          top_up_status = 2 //不能充值 已过期 ｜ 未激活
        }
        if (value.joyRsp === 2) {
          // 漫游卡保存
          localStorage.setItem('isRoaming', 'true')
        } else {
          localStorage.removeItem('isRoaming')
        }
        document.querySelector('.invalid-status-2').classList.add('hide');
        document.querySelector('.invalid-status-3').classList.add('hide');
        if (top_up_status !== 1) {
          showError('')
          if (top_up_status === 2) {
            document.querySelector('.invalid-status-2').classList.remove('hide');
          }
          return
        } 
        toNextStep(data, currentInput.value, product_id)
      } else {
        throw new Error(res?.msg || res.code);
      }
    })
    .catch((err) => {
      const lang = document.documentElement.getAttribute('lang')
      const errorMessage = err.message || err.toString()
      const currentInput = getCurrentInput();
      if (!currentInput) return;
      
      if (errorMessage.includes('CID does not exist')) {
        if (lang === 'en') {
          currentInput.setAttribute("data-result", "Invalid activation code.")
        } else if (lang === 'ja') {
          currentInput.setAttribute("data-result", "アクティベーションコードが正しくありません。")
        }
      } else if (errorMessage.includes('检查失败，HTTP状态码：422')) {
        if (lang === 'en') {
          currentInput.setAttribute("data-result", "eSIM is not activated or has expired, recharging is not possible.")
        } else if (lang === 'ja') {
          currentInput.setAttribute("data-result", "eSIMが未アクティベートまたは有効期限切れ、リチャージはできません。")
        }
      } else if (!isNaN(Number(err))) {
        if (lang === 'en') {
          currentInput.setAttribute("data-result", "Resuest Error: " + err)
        } else {
          currentInput.setAttribute("data-result", "リクエストエラー: " + err)
        }
      } else {
        currentInput.setAttribute("data-result", err.message || err);
      }
    })
    .finally(() => {
      setBtnLoading(false);
    });
});


function toNextStep(data, activeID, productID) {
  const currentInput = getCurrentInput();
  if (currentInput) {
    currentInput.value = "";
  }
  hideError();
  setBtnDisabled(true);
  
  if (data) {
    updateStep2Data(data);
  }

  if (activeID || productID) {
    updateURL(activeID, productID);
  }
  
  const stepWizard = document.querySelector("step-wizard");
  if (stepWizard) {
    stepWizard.activateStep(2);
  }
}

function updateURL(activeID, productID) {
  const url = new URL(window.location);
  if (activeID) {
    url.searchParams.set('active_id', activeID);
  }
  if (productID) {
    url.searchParams.set('product_id', productID);
  }
  history.pushState({ activeID, productID }, '', url.toString());
}

document.addEventListener("DOMContentLoaded", init);

function updateStep2Data(data) {
  data.forEach(item => {
    const element = document.querySelector(`.${item.label}`);
    if (element) {
      element.textContent = item.value || '--';
       if (item.label === 'remain_date_value' && (item.value <= 5 || item.value === '期限切れ' || item.value === 'Expired')) {
        element.closest('.info-value').classList.add('highlight-red');
        const unit = document.querySelector('.date_unit')
        if ((item.value === '期限切れ' || item.value === 'Expired') && unit) {
          unit.classList.add('hide')
        }
      }
    }
  });
}

// 二维码扫描成功后的通用处理函数
function handleQRScanSuccess(qrData) {
  const qrcodeInput = document.getElementById("qrcode-input");
  if (qrcodeInput) {
    if (qrData.split("$")[2]) {
      qrcodeInput.value = qrData.split("$")[2];
    } else {
      qrcodeInput.value = qrData;
    }
    // 触发输入事件
    qrcodeInput.dispatchEvent(new Event("input", { bubbles: true }));
  }
}

// 获取错误消息
function getQRScanErrorMessage(errorType) {
  const lang = document.documentElement.getAttribute('lang') || 'en';
  
  if (errorType === 'camera') {
    return lang === 'ja' 
      ? 'QRコードのスキャンに失敗しました。カメラの権限を確認するか、手動で入力してください。'
      : lang === 'zh'
      ? '二维码扫描失败，请检查相机权限或手动输入'
      : 'QR scan failed, please check camera permissions or enter manually';
  } else if (errorType === 'gallery') {
    return lang === 'ja' 
      ? 'QRコードが見つかりませんでした。別の画像を選択してください。'
      : lang === 'zh'
      ? '未检测到二维码，请选择其他图片'
      : 'No QR code detected, please select another image';
  }
  
  return 'An error occurred';
}

// 创建并显示选择弹窗（摄像头/相册）
function showSourceSelectionModal() {
  // 如果弹窗已存在，直接显示
  let modal = document.getElementById('source-selection-modal');
  
  if (!modal) {
    // 创建弹窗
    modal = document.createElement('div');
    modal.id = 'source-selection-modal';
    modal.className = 'source-selection-modal';
    
    const lang = document.documentElement.getAttribute('lang') || 'en';
    const cameraText = lang === 'ja' ? 'カメラを開く' : lang === 'zh' ? '打开摄像头' : 'Open Camera';
    const galleryText = lang === 'ja' ? 'アルバムから選択' : lang === 'zh' ? '从相册选择' : 'Select from Gallery';
    const cancelText = lang === 'ja' ? 'キャンセル' : lang === 'zh' ? '取消' : 'Cancel';
    
    modal.innerHTML = `
      <div class="source-selection-modal-overlay"></div>
      <div class="source-selection-modal-content">
        <div class="source-selection-header">
          <h3>${lang === 'ja' ? '入力方法を選択' : lang === 'zh' ? '选择输入方式' : 'Select Input Method'}</h3>
          <button class="source-selection-close" aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 10.9163L2.29278 17.6236C2.04182 17.8745 1.72243 18 1.3346 18C0.946768 18 0.627376 17.8745 0.376425 17.6236C0.125475 17.3726 0 17.0532 0 16.6654C0 16.2776 0.125475 15.9582 0.376425 15.7072L7.08365 9L0.376425 2.29278C0.125475 2.04182 0 1.72243 0 1.3346C0 0.946768 0.125475 0.627376 0.376425 0.376425C0.627376 0.125475 0.946768 0 1.3346 0C1.72243 0 2.04182 0.125475 2.29278 0.376425L9 7.08365L15.7072 0.376425C15.9582 0.125475 16.2776 0 16.6654 0C17.0532 0 17.3726 0.125475 17.6236 0.376425C17.8745 0.627376 18 0.946768 18 1.3346C18 1.72243 17.8745 2.04182 17.6236 2.29278L10.9163 9L17.6236 15.7072C17.8745 15.9582 18 16.2776 18 16.6654C18 17.0532 17.8745 17.3726 17.6236 17.6236C17.3726 17.8745 17.0532 18 16.6654 18C16.2776 18 15.9582 17.8745 15.7072 17.6236L9 10.9163Z" fill="currentColor"/>
            </svg>
          </button>
        </div>
        <div class="source-selection-buttons">
          <button class="source-selection-btn camera-btn" id="open-camera-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 4H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>${cameraText}</span>
          </button>
          <button class="source-selection-btn gallery-btn" id="open-gallery-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 19V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 10L3 16H21L15 10L12 13L9 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>${galleryText}</span>
          </button>
        </div>
        <button class="source-selection-cancel" id="cancel-selection-btn">${cancelText}</button>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    // 绑定事件
    const overlay = modal.querySelector('.source-selection-modal-overlay');
    const closeBtn = modal.querySelector('.source-selection-close');
    const cancelBtn = modal.querySelector('#cancel-selection-btn');
    const cameraBtn = modal.querySelector('#open-camera-btn');
    const galleryBtn = modal.querySelector('#open-gallery-btn');
    
    // 关闭弹窗的事件
    const closeModal = () => {
      hideSourceSelectionModal();
    };
    
    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
    cancelBtn.addEventListener('click', closeModal);
    
    // 打开摄像头
    cameraBtn.addEventListener('click', () => {
      closeModal();
      if (window.qrScanner) {
        window.qrScanner.open(
          handleQRScanSuccess,
          (error) => {
            console.error("QR scan failed:", error);
            alert(getQRScanErrorMessage('camera'));
          }
        );
      }
    });
    
    // 从相册选择
    galleryBtn.addEventListener('click', () => {
      closeModal();
      if (window.qrScanner) {
        window.qrScanner.onSuccess = handleQRScanSuccess;
        window.qrScanner.onError = (error) => {
          console.error("Gallery selection failed:", error);
          alert(getQRScanErrorMessage('gallery'));
        };
        window.qrScanner.selectFromGallery();
      }
    });
  }
  
  // 显示弹窗
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
}

// 隐藏选择弹窗
function hideSourceSelectionModal() {
  const modal = document.getElementById('source-selection-modal');
  if (modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// 初始化"查看我的 eSIM"按钮
function initViewEsimButton() {
  const viewEsimBtn = document.getElementById('view-esim-btn');
  if (!viewEsimBtn) return;
  
  viewEsimBtn.addEventListener('click', () => {
    showEsimListModal();
  });
}

// 显示 eSIM 列表弹窗
function showEsimListModal() {
  // 先显示 loading 弹窗
  showEsimLoadingModal();
  
  // 加载数据
  loadEsimList();
}

// 显示 eSIM loading 弹窗
function showEsimLoadingModal() {
  let loadingModal = document.getElementById('esim-loading-modal');
  
  if (!loadingModal) {
    loadingModal = document.createElement('div');
    loadingModal.id = 'esim-loading-modal';
    loadingModal.className = 'esim-loading-modal';
    
    const lang = document.documentElement.getAttribute('lang') || 'ja';
    const loadingText = lang === 'ja' ? '読み込み中...' : lang === 'zh' ? '加载中...' : 'Loading...';
    
    loadingModal.innerHTML = `
      <div class="esim-loading-overlay"></div>
      <div class="esim-loading-content">
        <div class="esim-loading-spinner"></div>
        <div class="esim-loading-text">${loadingText}</div>
      </div>
    `;
    
    document.body.appendChild(loadingModal);
  }
  
  loadingModal.classList.add('active');
  document.body.style.overflow = 'hidden';
}

// 隐藏 eSIM loading 弹窗
function hideEsimLoadingModal() {
  const loadingModal = document.getElementById('esim-loading-modal');
  if (loadingModal) {
    loadingModal.classList.remove('active');
  }
}

// 创建并显示 eSIM 列表弹窗
function createAndShowEsimListModal() {
  let modal = document.getElementById('esim-list-modal');
  
  if (!modal) {
    // 创建弹窗
    modal = document.createElement('div');
    modal.id = 'esim-list-modal';
    modal.className = 'esim-list-modal';
    
    const lang = document.documentElement.getAttribute('lang') || 'ja';
    const titleText = lang === 'ja' ? '私のeSIM' : lang === 'zh' ? '我的 eSIM' : 'My eSIM';
    
    modal.innerHTML = `
      <div class="esim-list-modal-overlay"></div>
      <div class="esim-list-modal-content">
        <div class="esim-list-modal-header">
          <h3>${titleText}</h3>
          <button class="esim-list-modal-close" aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 10.9163L2.29278 17.6236C2.04182 17.8745 1.72243 18 1.3346 18C0.946768 18 0.627376 17.8745 0.376425 17.6236C0.125475 17.3726 0 17.0532 0 16.6654C0 16.2776 0.125475 15.9582 0.376425 15.7072L7.08365 9L0.376425 2.29278C0.125475 2.04182 0 1.72243 0 1.3346C0 0.946768 0.125475 0.627376 0.376425 0.376425C0.627376 0.125475 0.946768 0 1.3346 0C1.72243 0 2.04182 0.125475 2.29278 0.376425L9 7.08365L15.7072 0.376425C15.9582 0.125475 16.2776 0 16.6654 0C17.0532 0 17.3726 0.125475 17.6236 0.376425C17.8745 0.627376 18 0.946768 18 1.3346C18 1.72243 17.8745 2.04182 17.6236 2.29278L10.9163 9L17.6236 15.7072C17.8745 15.9582 18 16.2776 18 16.6654C18 17.0532 17.8745 17.3726 17.6236 17.6236C17.3726 17.8745 17.0532 18 16.6654 18C16.2776 18 15.9582 17.8745 15.7072 17.6236L9 10.9163Z" fill="currentColor"/>
            </svg>
          </button>
        </div>
        <div class="esim-list-modal-body">
          <div class="esim-list-container"></div>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    // 绑定关闭事件
    const overlay = modal.querySelector('.esim-list-modal-overlay');
    const closeBtn = modal.querySelector('.esim-list-modal-close');
    
    const closeModal = () => {
      hideEsimListModal();
    };
    
    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
  }
  
  // 显示弹窗（从底部滑入）
  modal.classList.add('active');
}

// 隐藏 eSIM 列表弹窗
function hideEsimListModal() {
  const modal = document.getElementById('esim-list-modal');
  if (modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// 加载 eSIM 列表
function loadEsimList() {
  // 获取 lineId
  const urlParams = new URLSearchParams(window.location.search);
  const lineId = urlParams.get("lineId") || sessionStorage.getItem("lineId") || "";
  
  if (!lineId) {
    const lang = document.documentElement.getAttribute('lang') || 'ja';
    const noLineText = lang === 'ja' ? 'Line IDが見つかりません' : lang === 'zh' ? '未找到 Line ID' : 'Line ID not found';
    // 隐藏 loading，显示列表弹窗（无数据）
    hideEsimLoadingModal();
    createAndShowEsimListModal();
    const container = document.querySelector('.esim-list-container');
    if (container) {
      container.innerHTML = `<div class="no-items-found">${noLineText}</div>`;
    }
    return;
  }
  
  // 调用 getUserCard 函数（从 step0.js 中定义）
  if (typeof getUserCard === 'function') {
    getUserCard(lineId)
      .then((list) => {
        // 隐藏 loading，显示列表弹窗
        hideEsimLoadingModal();
        createAndShowEsimListModal();
        const container = document.querySelector('.esim-list-container');
        if (container) {
          renderEsimListInModal(list, container);
        }
      })
      .catch((e) => {
        // 隐藏 loading，显示列表弹窗（错误）
        hideEsimLoadingModal();
        createAndShowEsimListModal();
        const container = document.querySelector('.esim-list-container');
        if (container) {
          const errorMsg = e.message || e.toString();
          container.innerHTML = `<div class="no-items-found">${errorMsg}</div>`;
        }
      });
  } else {
    // 隐藏 loading，显示列表弹窗（函数不可用）
    hideEsimLoadingModal();
    createAndShowEsimListModal();
    const container = document.querySelector('.esim-list-container');
    if (container) {
      container.innerHTML = '<div class="no-items-found">Function not available</div>';
    }
  }
}

// 在弹窗中渲染 eSIM 列表
function renderEsimListInModal(list, container) {
  if (!container) return;
  
  container.innerHTML = '';
  
  if (!list || list.length === 0) {
    const lang = document.documentElement.getAttribute('lang') || 'ja';
    const noItemsText = lang === 'ja' ? 'No Data' : lang === 'zh' ? 'No Data' : 'No Data';
    container.innerHTML = `<div class="no-items-found">${noItemsText}</div>`;
    return;
  }
  
  list.forEach((item) => {
    const card = document.createElement('div');
    card.classList.add('esimCard');
    if (item.disabled) {
      card.classList.add('disabled');
    }
    
    const lang = document.documentElement.getAttribute('lang') || 'ja';
    const statusText = lang === 'ja' ? 'ステータス' : lang === 'zh' ? '状态' : 'Status';
    const activeDateText = lang === 'ja' ? 'アクティベート日' : lang === 'zh' ? '激活日期' : 'Activation Date';
    
    const cover = !item.cover ? esimImageCover : `<img src="${item.cover}" alt="${item.name}" />`;
    card.innerHTML = `
      <div class="header-card">
        <div class="cover">
          ${cover}
        </div>
        <div class="title-card two-line-ellipsis">
          ${item.name}
        </div>
      </div>
      <div class="detail-content">
        <p class="detail-content-left">${statusText}</p>
        <p class="detail-content-right status-text" style="background: ${getBackground(item.esimStatus)}">${getStatusValue(item.esimStatus)}</p>
      </div>
      <div class="detail-content">
        <p class="detail-content-left">${activeDateText}</p>
        <p class="detail-content-right">${item.departureDate || '--'}</p>
      </div>
    `;
    
    // 添加点击事件 - 选中 eSIM 并填入激活码
    if (!item.disabled && item.activationCode) {
      card.style.cursor = 'pointer';
      card.addEventListener('click', () => {
        selectEsim(item.activationCode);
      });
    } else if (item.disabled) {
      // disabled 的 card 点击时显示错误提示
      card.addEventListener('click', () => {
        const lang = document.documentElement.getAttribute('lang') || 'ja';
        let errorMessage = '';
        if (lang === 'ja') {
          errorMessage = 'このeSIMはリチャージできません';
        } else if (lang === 'zh' || lang === 'zh-CN') {
          errorMessage = '此 eSIM 无法充值';
        } else {
          errorMessage = 'This eSIM cannot be recharged';
        }
        if (typeof Message !== 'undefined' && Message.error) {
          Message.error(errorMessage, 1200);
        }
      });
    }
    
    container.appendChild(card);
  });
}

// 选中 eSIM 并填入激活码
function selectEsim(activationCode) {
  const iccidInput = document.getElementById('iccid-input');
  if (iccidInput && activationCode) {
    iccidInput.value = activationCode;
    // 触发输入事件以更新按钮状态
    iccidInput.dispatchEvent(new Event("input", { bubbles: true }));
    // 关闭弹窗
    hideEsimListModal();
  }
}
